export const 
    defense_bundle_icon = require('./defense_bundle_icon.svg'),
    everyday_bundle_icon = require('./everyday_bundle_icon.svg'),
    kitchen_bundle_icon = require('./kitchen_bundle_icon.svg'),
    laundry_bundle_icon = require('./laundry_bundle_icon.svg'),
    defense_bundle_hero = require('./defense_bundle_hero.png'),
    everyday_bundle_hero = require('./everyday_bundle_hero.png'),
    kitchen_bundle_hero = require('./kitchen_bundle_hero.png'),
    laundry_bundle_hero = require('./laundry_bundle_hero.png')